
export function request() {
    return {
        type: 'GET_RELATED_CONTINGENCY_REQUEST'
    };
}

export function error(errors) {
    return {
        type: 'GET_RELATED_CONTINGENCY_ERROR',
        errors
    };
}

export function finish(items) {
    return {
        type: 'GET_RELATED_CONTINGENCY_FINISH',
        items
    };
}
